import pickBy from 'lodash/pickBy'
import URLSearchParams from 'url-search-params'

export const noop = () => null

/**
 * Returns an inclusive range from low to high, or empty list if low > high
 * @param {String|Number} low
 * @param {String|Number} high
 */
export const range = (low, high) => {
  if (low === '' || high === '') {
    return []
  }
  const len = Number(high) - Number(low) + 1
  return [...Array(len > 0 ? len : 0).keys()].map(i => Number(low) + i)
}

/**
 * Split total number into an array, evenly distributing the total with remainders at the front.
 * e.g. `evenSplit(100, 5) -> [20, 20, 20, 20, 20]`
 * e.g. `evenSplit(100, 3) -> [34, 33, 33]`
 * @param {Number} total
 * @param {Number} length
 */
export const evenSplit = (total, length) => {
  const remainders = total % length
  const split = Math.floor(total / length)
  return [...Array(length)].map((_, index) =>
    index < remainders ? split + 1 : split
  )
}

/**
 * Returns a new object consisting of the entries of `obj` which keys start with `substr`.
 * @param {Object} obj
 * @param {String} substr
 */
export const pickKeysThatStartWith = (obj, substr) =>
  pickBy(obj, (val, key) => val && key.startsWith(substr))

export const commaify = val =>
  val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const searchParams = () => new URLSearchParams(window.location.search)

export const redirectCancel = () =>
  (window.location.href = `${searchParams().get('origin')}/${searchParams().get(
    'cancel-path'
  )}`)

export const redirectDone = uuid =>
  window.location.replace(
    `${searchParams().get('origin')}/${searchParams()
      .get('redirect-path')
      .replace('.uuid.', uuid)}`
  )

export const jwtValue = key =>
  JSON.parse(
    atob(
      searchParams()
        .get('de-jwt')
        .split('.')[1]
    )
  )[key]

export const sampleName = () => {
  const maxLen = 54
  const maxOriginLen = 30
  const separator = ' - '
  // Remove all except lowest-level non-www domain
  const origin = searchParams()
    .get('origin')
    .toString()
    .replace(/https?:\/\/(www\.)?/, '')
    .replace(/\..+$/, '')
    .substring(0, maxOriginLen)
  const maxPathLen = maxLen - origin.length - separator.length
  // Reverse indexed slice of path limited to max length
  const path = jwtValue('path')
    .toString()
    .slice(-maxPathLen)
  return `${origin}${separator}${path}`
}



// WEBPACK FOOTER //
// ./src/utils/index.js